import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios';
import config from '../config';

type TokenGetter = () => Promise<string | null>;

let clerkTokenGetter: TokenGetter | null = null;

export const setClerkTokenGetter = (getter: TokenGetter | null) => {
  clerkTokenGetter = getter;
};

const axiosInstance: AxiosInstance = axios.create({
  baseURL: config.apiUrl,
});

axiosInstance.interceptors.request.use(
  async (requestConfig: InternalAxiosRequestConfig) => {
    if (clerkTokenGetter) {
      try {
        const token = await clerkTokenGetter();
        if (token) {
          requestConfig.headers.Authorization = `Bearer ${token}`;
        }
      } catch (err) {
        console.error('[axios] Failed to get Clerk token:', err);
      }
    }
    return requestConfig;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;
